<!-- Created by henian.xu on 2025/11/24. -->

<template>
    <div class="date-interval">
        <div>{{value_}}</div>
        <div class="inner">
            <DatePicker
                placeholder="请选择开始日期"
                v-model="beginDate"></DatePicker>
            <div
                v-if="isClear && beginDate"
                class="icon"
                @click="onClearBeginDate"
            ><XIcon
                content="f01a"
                theme="g6"
                block></XIcon
                ></div>
            <div class="interval">至</div>
            <DatePicker
                placeholder="请选择结束日期"
                v-model="endDate"></DatePicker>
            <div
                v-if="isClear && endDate"
                class="icon"
                @click="onClearEndDate"
            ><XIcon
                content="f01a"
                theme="g6"
                block></XIcon
                ></div>
        </div>
    </div>
</template>

<script>
import Moment from 'dayjs';
import { formMixin } from 'packages/mixins';

export default {
    name: 'DateInterval',
    mixins: [formMixin],
    data() {
        return {
            value_: null,
            innerCtrl__: false,
        };
    },
    props: {
        value: { type: Object, default: null },
        isClear: { type: Boolean, default: false },
    },
    computed: {
        model: {
            get() {
                const { value, value_ } = this;
                return value !== null ? value : value_;
            },
            set(val) {
                const { beginDate, endDate } = val;
                let value = val;
                const begin = beginDate ? Moment(beginDate).valueOf() || 0 : 0;
                const end = endDate ? Moment(endDate).valueOf() || 0 : 0;
                if (begin && end && begin > end) {
                    value = {
                        beginDate: endDate,
                        endDate: beginDate,
                    };
                }
                this.innerCtrl__ = true;
                if (this.value === null) this.value_ = value;
                this.$emit('input', value);
            },
        },
        beginDate: {
            get() {
                const { beginDate } = this.model || {};
                return beginDate || '';
            },
            set(val) {
                this.model = {
                    ...this.model,
                    beginDate: val,
                };
            },
        },
        endDate: {
            get() {
                const { endDate } = this.model || {};
                return endDate || '';
            },
            set(val) {
                this.model = {
                    ...this.model,
                    endDate: val,
                };
            },
        },
    },
    methods: {
        onClearBeginDate() {
            this.beginDate = '';
        },
        onClearEndDate() {
            this.endDate = '';
        },
    },
};
</script>

<style lang="scss">
.date-interval {
    > .inner {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        > .icon {
            margin: 0 $margin-small 4px $margin-small;
        }

        > .interval {
            margin: 0 $margin-small;
        }
    }
}
</style>
